import React from 'react'
import {CardPanel, Row, Col} from 'react-materialize'

const ErrorCard = ({errorText}) => {
  return (
    <Row>
      <Col s={12}>
        <CardPanel className="red">
          <span className="white-text">
            {errorText}
          </span>
        </CardPanel>
      </Col>
    </Row>
  )
}

export default ErrorCard
